// components/OrderDetailsSection.js - Updated with custom CSS classes
import React from 'react';
import Section from './Section';
import './OrderDetailsSection.css'; // Import the dedicated CSS file

export default function OrderDetailsSection({ orderDetails, setOrderDetails, isEditing }) {
  const handleDetailChange = (e) => {
    const { name, value, type, checked } = e.target;
    setOrderDetails((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleDropChange = (index, field, value) => {
    const newDrops = [...orderDetails.drops];
    newDrops[index][field] = value;
    setOrderDetails((prev) => ({ ...prev, drops: newDrops }));
  };

  const addDrop = () => {
    setOrderDetails((prev) => ({
      ...prev,
      drops: [...prev.drops, { startDate: '', endDate: '', dduDate: '', quantity: '' }],
    }));
  };

  const removeDrop = (index) => {
    const updatedDrops = orderDetails.drops.filter((_, i) => i !== index);
    setOrderDetails((prev) => ({
      ...prev,
      drops: updatedDrops.length > 0 ? updatedDrops : [{ startDate: '', endDate: '', dduDate: '' }],
    }));
  };

  return (
    <Section title="Order Details" defaultOpen={false}>
      <div className="order-details-container">
        <div className="order-details-layout">
          {/* Main Fields - Horizontal Row with Staffed Event */}
          <div className="order-details-main-grid">
            <div className="order-details-field-group">
              <select
                name="campaignName"
                disabled={!isEditing}
                value={orderDetails.campaignName}
                onChange={handleDetailChange}
                className="order-details-select"
              >
                <option value="">Select Job Name</option>
                <option value="Blowout Event">Blowout Event</option>
                <option value="Mega Markdown">Mega Markdown</option>
                <option value="Deal or No Deal">Deal or No Deal</option>
                <option value="Vehicle Exchange Program">Vehicle Exchange Program</option>
                <option value="2 Part Buyback w/ Check">2 Part Buyback w/ Check</option>
                <option value="2 Part Buyback w/ Check">2 Part Buyback w/ Check</option>
                <option value="Loan & Lease Termination">Loan & Lease Termination</option>
                <option value="Swap Keys & Trade-up">Swap Keys & Trade-up</option>
                <option value="Titanium Funding">Titanium Funding</option>
                <option value="Freedom Card">Freedom Card</option>
                <option value="Carbonless Impact">Carbonless Impact</option>
                <option value="Other">Other</option>
              </select>
              <div className="order-details-label">Campaign Name</div>
            </div>

            <div className="order-details-field-group">
              <select
                name="size"
                disabled={!isEditing}
                value={orderDetails.size}
                onChange={handleDetailChange}
                className="order-details-select"
              >
                <option value="">Select Size</option>
                <option value="9x6">9x6</option>
                <option value="7x9">7x9</option>
                <option value="6x11">6x11</option>
                <option value="8.5x11">8.5x11</option>
                <option value="8.5x14">8.5x14</option>
                <option value="9x12">9x12</option>
                <option value="11x14">11x14</option>
                <option value="11x17">11x17</option>
                <option value="14x22">14x22</option>
                <option value="Other">Other</option>
              </select>
              <div className="order-details-label">Size</div>
            </div>

            <div className="order-details-field-group">
              <select
                name="attachment"
                disabled={!isEditing}
                value={orderDetails.attachment}
                onChange={handleDetailChange}
                className="order-details-select"
              >
                <option value="">Select Attachment</option>
                <option value="Combination Box">Combination Box</option>
                <option value="Key & Scratch-Off">Key & Scratch-Off</option>
                <option value="Scratch Off">Scratch-Off</option>
                <option value="Scratch Off (2)">Scratch-Off (2)</option>
                <option value="Scratch-Off & Integrated Pull Tab">Scratch-Off & Integrated Pull Tab</option>
                <option value="Peel2Win Sticker">Peel2Win Sticker</option>
                <option value="PostIt Note">Post-It Note</option>
                <option value="PullTab">PullTab</option>
                <option value="Gift Card">Gift Card</option>
                <option value="N/A">N/A</option>
                <option value="Other">Other</option>
              </select>
              <div className="order-details-label">Attachment</div>
            </div>

            <div className="order-details-field-group">
  <select
    name="paperType"
    disabled={!isEditing}
    value={orderDetails.paperType}
    onChange={handleDetailChange}
    className="order-details-select"
  >
    <option value="">Select Paper Type</option>
    <option value="#100 Gloss Cover">#100 Gloss Cover</option>
    <option value="#80 Gloss Text">#80 Gloss Text</option>
    <option value="9 pt silk cover">9 pt Silk Cover</option>
    <option value="Offset">Offset</option>
    <option value="Laminated">Laminated</option>
    <option value="Gloss Text">Gloss Text</option>
    <option value="standard">Standard</option>
    <option value="Snap-Pack">Snap-Pack</option>
    <option value="Carbonless">Carbonless</option>
    <option value="N/A">N/A</option>
    <option value="Other">Other</option>
  </select>
  <div className="order-details-label">Paper Type</div>
</div>

            <div className="order-details-field-group">
              <select
                name="printer"
                disabled={!isEditing}
                value={orderDetails.printer}
                onChange={handleDetailChange}
                className="order-details-select"
              >
                <option value="">Select Printer</option>
                <option value="G2PN">G2PN</option>
                <option value="JSDirect">JSDirect</option>
                <option value="CoOp">CoOp</option>
                <option value="Midlantic">Midlantic</option>
                <option value="N/A">N/A</option>
                <option value="Other">Other</option>
              </select>
              <div className="order-details-label">Printer</div>
            </div>

            

            <div className="order-details-field-group">
              <input
                type="number"
                disabled={!isEditing}
                name="quantity"
                placeholder="50000"
                value={orderDetails.quantity}
                onChange={handleDetailChange}
                className="order-details-input"
              />
              <div className="order-details-label">Total Quantity</div>
            </div>

            <div className="order-details-field-group">
              <select
                name="sort"
                disabled={!isEditing}
                value={orderDetails.sort}
                onChange={handleDetailChange}
                className="order-details-select"
              >
                <option value="">Select Sort</option>
                <option value="Standard Mail to DDU">Standard Mail to DDU</option>
                <option value="Deliver to Dealership">Deliver to Dealership</option>
                <option value="Letter Mail to SCF">Letter Mail to SCF</option>
                <option value="N/A">N/A</option>
                <option value="Other">Other</option>
              </select>
              <div className="order-details-label">Sort Method</div>
            </div>

            {/* Staffed Event Checkbox in Main Grid */}
            <div className="order-details-checkbox-main">
              <label className="order-details-checkbox-wrapper-main">
                <input
                  type="checkbox"
                  name="staffed"
                  disabled={!isEditing}
                  checked={orderDetails.staffed}
                  onChange={handleDetailChange}
                  className="order-details-checkbox"
                />
                <span> </span>
              </label>
              <div className="order-details-label">Staffed Event</div>
            </div>
          </div>

          {/* Secondary Row for Custom Fields Only */}
          <div className="order-details-secondary-row">
            {/* Custom "Other" Fields */}
            {orderDetails.campaignName === 'Other' && (
              <div className="order-details-custom-section">
                <div className="order-details-custom-field">
                  <input
                    type="text"
                    name="campaignNameOther"
                    disabled={!isEditing}
                    placeholder="Enter custom campaign name"
                    value={orderDetails.campaignNameOther}
                    onChange={handleDetailChange}
                    className="order-details-custom-input"
                  />
                  <div className="order-details-custom-label">Custom Campaign Name</div>
                </div>
              </div>
            )}

            {orderDetails.size === 'Other' && (
              <div className="order-details-custom-section">
                <div className="order-details-custom-field">
                  <input
                    type="text"
                    disabled={!isEditing}
                    name="sizeOther"
                    placeholder="Enter custom size (e.g., 12x18)"
                    value={orderDetails.sizeOther}
                    onChange={handleDetailChange}
                    className="order-details-custom-input"
                  />
                  <div className="order-details-custom-label">Custom Size</div>
                </div>
              </div>
            )}

            {orderDetails.attachment === 'Other' && (
              <div className="order-details-custom-section">
                <div className="order-details-custom-field">
                  <input
                    type="text"
                    name="attachmentOther"
                    placeholder="Enter custom attachment type"
                    value={orderDetails.attachmentOther}
                    onChange={handleDetailChange}
                    className="order-details-custom-input"
                  />
                  <div className="order-details-custom-label">Custom Attachment</div>
                </div>
              </div>
            )}

            {orderDetails.paperType === 'Other' && (
  <div className="order-details-custom-section">
    <div className="order-details-custom-field">
      <input
        type="text"
        name="paperTypeOther"
        disabled={!isEditing}
        placeholder="Enter custom paper type"
        value={orderDetails.paperTypeOther}
        onChange={handleDetailChange}
        className="order-details-custom-input"
      />
      <div className="order-details-custom-label">Custom Paper Type</div>
    </div>
  </div>
)}

            {orderDetails.printer === 'Other' && (
              <div className="order-details-custom-section">
                <div className="order-details-custom-field">
                  <input
                    type="text"
                    name="printerOther"
                    placeholder="Enter custom printer name"
                    value={orderDetails.printerOther}
                    onChange={handleDetailChange}
                    className="order-details-custom-input"
                  />
                  <div className="order-details-custom-label">Custom Printer</div>
                </div>
              </div>
            )}

            {orderDetails.sort === 'Other' && (
              <div className="order-details-custom-section">
                <div className="order-details-custom-field">
                  <input
                    type="text"
                    name="sortOther"
                    placeholder="Enter custom sort method"
                    value={orderDetails.sortOther}
                    onChange={handleDetailChange}
                    className="order-details-custom-input"
                  />
                  <div className="order-details-custom-label">Custom Sort Method</div>
                </div>
              </div>
            )}
          </div>

          {/* Full Width Notes Section */}
          <div className="order-details-notes-full-width">
            <div className="order-details-notes-field">
              <textarea
                name="notes"
                disabled={!isEditing}
                placeholder="Enter any additional notes, special instructions, or requirements for this order..."
                value={orderDetails.notes}
                onChange={handleDetailChange}
                className="order-details-textarea"
                rows={3}
              />
              <div className="order-details-notes-label">Additional Notes</div>
            </div>
          </div>

          {/* Drop Dates Section - Stacked Rows */}
          <div className="order-details-drops-section">
            <h4 className="order-details-drops-title">Drop Dates & Quantities</h4>
            
            <div className="order-details-drops-container">
              {orderDetails.drops.map((drop, idx) => (
                <div key={idx} className="order-details-drop-row">
                  <div className="order-details-drop-number">#{idx + 1}</div>
                  
                  <div className="order-details-drop-field">
                    <input
                      type="date"
                      disabled={!isEditing}
                      value={drop.startDate}
                      onChange={(e) => handleDropChange(idx, 'startDate', e.target.value)}
                      className="order-details-date-input"
                    />
                    <div className="order-details-drop-label">Start Date</div>
                  </div>
                  
                  <div className="order-details-drop-field">
                    <input
                      type="date"
                      disabled={!isEditing}
                      value={drop.endDate}
                      onChange={(e) => handleDropChange(idx, 'endDate', e.target.value)}
                      className="order-details-date-input"
                    />
                    <div className="order-details-drop-label">End Date</div>
                  </div>
                  
                  <div className="order-details-drop-field">
                    <input
                      type="date"
                      disabled={!isEditing}
                      value={drop.dduDate}
                      onChange={(e) => handleDropChange(idx, 'dduDate', e.target.value)}
                      className="order-details-date-input"
                    />
                    <div className="order-details-drop-label">DDU Date</div>
                  </div>
                  
                  <div className="order-details-drop-field">
                    <input
                      type="number"
                      disabled={!isEditing}
                      placeholder="25000"
                      value={drop.quantity || ''}
                      onChange={(e) => handleDropChange(idx, 'quantity', e.target.value)}
                      className="order-details-quantity-input"
                    />
                    <div className="order-details-drop-label">Quantity</div>
                  </div>
                  
                  <button
                    type="button"
                    disabled={!isEditing || orderDetails.drops.length <= 1}
                    onClick={() => removeDrop(idx)}
                    className="order-details-delete-button"
                  >
                    Delete
                  </button>
                </div>
              ))}
              
              <div className="order-details-add-section">
                <div className="order-details-add-field">
                  <button
                    type="button"
                    disabled={!isEditing}
                    onClick={addDrop}
                    className="order-details-add-button"
                  >
                    Add Another Drop
                  </button>
                  <div className="order-details-add-label">Add Drop Date</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}